module.exports = __webpack_public_path__ + "img/Veranza-21-min.4693a5ac.jpg";